<script setup lang="ts">
import BankAccountsDirectoryContainer from './containers/BankAccountsDirectoryContainer.vue'
</script>

<template>
  <BankAccountsDirectoryContainer />
</template>
